import { render, staticRenderFns } from "./inventoryXADate.vue?vue&type=template&id=cc1a664a&scoped=true"
import script from "./inventoryXADate.vue?vue&type=script&lang=js"
export * from "./inventoryXADate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc1a664a",
  null
  
)

export default component.exports